// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StarsFeedback__popup-dc566a {
  min-width: 440px;
  background: var(--base-0);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.StarsFeedback__title-f650d6 {
  font: var(--font-title-6);
  color: var(--base-110);
  margin-bottom: 4px;
}

.StarsFeedback__sub-title-d03e91 {
  font: var(--font-body-4);
  color: var(--base-110);
  letter-spacing: var(--font-spacing-body-4);
  margin-bottom: 32px;
}

.StarsFeedback__stars-container-d7d98a {
  display: flex;
  flex-direction: row-reverse;
  width: fit-content;
  padding: 2px;
  margin-bottom: 40px;
}

.StarsFeedback__star-da9161 {
  cursor: pointer;
  padding-inline-start: 4px;
  padding-inline-end: 4px;
}

.StarsFeedback__star-da9161:first-child {
  padding-inline-end: 0;
}

.StarsFeedback__star-da9161:last-child {
  padding-inline-start: 0;
}

.StarsFeedback__star-da9161:hover,
.StarsFeedback__star-da9161:active {
  background: transparent;
}

.StarsFeedback__star-da9161 svg {
  fill: var(--base-40);
}

.StarsFeedback__star-da9161:hover svg {
  fill: var(--addition-130);
}

.StarsFeedback__star-da9161:hover ~ .StarsFeedback__star-da9161 svg {
  fill: var(--addition-130);
}

.StarsFeedback__dont-show-container-bbfd0c {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/main/Popups/StarsFeedback/StarsFeedback.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,yBAAA;EACA,0CAAA;AACF;;AAEA;EACE,yBAAA;EACA,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,wBAAA;EACA,sBAAA;EACA,0CAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,yBAAA;EACA,uBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;;EAEE,uBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AACF","sourcesContent":[".popup {\n  min-width: 440px;\n  background: var(--base-0);\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n}\n\n.title {\n  font: var(--font-title-6);\n  color: var(--base-110);\n  margin-bottom: 4px;\n}\n\n.sub-title {\n  font: var(--font-body-4);\n  color: var(--base-110);\n  letter-spacing: var(--font-spacing-body-4);\n  margin-bottom: 32px;\n}\n\n.stars-container {\n  display: flex;\n  flex-direction: row-reverse;\n  width: fit-content;\n  padding: 2px;\n  margin-bottom: 40px;\n}\n\n.star {\n  cursor: pointer;\n  padding-inline-start: 4px;\n  padding-inline-end: 4px;\n}\n\n.star:first-child {\n  padding-inline-end: 0;\n}\n\n.star:last-child {\n  padding-inline-start: 0;\n}\n\n.star:hover,\n.star:active {\n  background: transparent;\n}\n\n.star svg {\n  fill: var(--base-40);\n}\n\n.star:hover svg {\n  fill: var(--addition-130);\n}\n\n.star:hover ~ .star svg {\n  fill: var(--addition-130);\n}\n\n.dont-show-container {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `StarsFeedback__popup-dc566a`,
	"title": `StarsFeedback__title-f650d6`,
	"sub-title": `StarsFeedback__sub-title-d03e91`,
	"subTitle": `StarsFeedback__sub-title-d03e91`,
	"stars-container": `StarsFeedback__stars-container-d7d98a`,
	"starsContainer": `StarsFeedback__stars-container-d7d98a`,
	"star": `StarsFeedback__star-da9161`,
	"dont-show-container": `StarsFeedback__dont-show-container-bbfd0c`,
	"dontShowContainer": `StarsFeedback__dont-show-container-bbfd0c`
};
module.exports = ___CSS_LOADER_EXPORT___;
